<script>
  import formatDate from "@/utils/date/format/index";
  import setSelectedFiltersOptions from "@/utils/input-output/set-selected-filters-options";
  import mixin from "../../mixin";

  export default {
    mixins: [mixin],
    data() {
      return {};
    },
    computed: {
      content() {
        return this.notification.content;
      },
      formattedMonth() {
        const options = {
          year: "numeric",
          month: "short",
        };
        return formatDate({ date: this.content.month, options });
      },

      formattedTarget() {
        return this.$root.formatNumber({
          number: this.content.target,
          notation: "compact",
        })
      },
    },
    methods: {
      goToPartnerTargets() {
        this.setNotificationAsRead()

        if (!this.canViewPartnerTargets || this.$router.currentRoute.name === "partners-targets") return;

        setSelectedFiltersOptions({
          route: "partners-targets",
          name: "partners",
          data: [{
            id: this.content.partner.id,
            name: this.content.partner.name,
          }],
        })

        const filtersData = this.storageFiltersData;
        filtersData["partners-targets"] = {
          month: this.content.month,
          buId: this.content.partner.buId || "",
          partners: [this.content.partner.id],
          sortMetrics: "",
          sortDirection: "asc",
        };
        this.setLocalStorage("filters", filtersData);
        this.$router.push({ name: "partners-targets" });
      },
    },
  };
</script>
<template>
  <div
    class="p-base-medium text-neutral-400 m-b-9"
    :class="{'cursor-pointer': canViewPartnerTargets }"
    @click="goToPartnerTargets"
  >
    <span class="m-r-3">{{
      $t(`notifications.${notification.type}.targetSetFor`)
    }}</span>
    <span class="text-neutral-900 m-r-3">{{ content.partner.name }}</span>
    <span class="m-r-3">{{ $t(`notifications.${notification.type}.forMonth`) }}</span>
    <span class="text-neutral-900 m-r-3">{{ formattedMonth }}</span>
    <span class="m-r-3">{{ $t(`notifications.${notification.type}.withValue`) }}</span>
    <span class="text-neutral-900">{{ formattedTarget }}</span>
  </div>
</template>
